import React from "react";
import { Smartphone } from "lucide-react";

const DesktopOnlyBlock = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 px-6 text-center">
      <Smartphone className="w-14 h-14 text-gray-700" />

      <h1 className="mt-6 text-2xl font-bold text-gray-800">
        Please view this on mobile
      </h1>

      <p className="mt-2 text-gray-600 max-w-sm">
        This application is optimized for mobile devices. Please open this link
        on your mobile phone for the best experience.
      </p>
    </div>
  );
};

export default DesktopOnlyBlock;
